import { useElasticidadeCruzadaStore } from '../../ElasticidadeCruzada.store';
import styles from './styles.module.scss';

export const CompetitivityCard = () => {
  const { marketShareResponse } = useElasticidadeCruzadaStore();

  const competitividade = marketShareResponse?.competitividade;

  if (!competitividade) return null;

  const { valor, descricao } = competitividade;
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(Number(valor ?? 0));

  return (
    <div className={styles.card}>
      <span className={styles.value}>{formattedValue}%</span>
      <span className={styles.title}>Competitividade Infopanel atual</span>
      {!!descricao && <p className={styles.description}>{descricao}</p>}
    </div>
  );
};
